import { Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { SpacesLibraryScreen } from './screens/SpacesLibrary/SpacesLibraryScreen'

/**
 * Spaces catalog — real Studio place prototypes (Hall, Mountain Lot, Furniture, Vision).
 * Opens under /galleries/:id/{suffix}; library lives at /spaces.
 */
export const spacesRouteElements = (
  <Route path='spaces' element={<AlbumShellLayout />}>
    <Route index element={<SpacesLibraryScreen />} />
  </Route>
)
